export interface Variant {
  node: {
    selectedOptions: {
      name: string;
      value: string;
    }[];
    title: string;
    quantityAvailable?: number;
  };
}

const findOptionStock = (optName: string, variants: Variant[]) => {
  // list unique option values across variants
  const options = variants.map(
    v =>
      v &&
      v.node &&
      v.node.selectedOptions &&
      v.node.selectedOptions.find(opt => opt.name === optName)?.value,
  );

  const uniqueOptions =
    options && options.filter((v, i) => options.indexOf(v) === i);

  // new arr of options with in/out of stock for each
  let optStk: {
    value: string;
    inStock: boolean;
  }[] = [];
  if (uniqueOptions) {
    optStk = uniqueOptions.map(uo => {
      const inStock = variants
        .filter(v => v.node.selectedOptions.some(opt => opt.value === uo))
        .some(v => v.node.quantityAvailable && v.node.quantityAvailable > 0);

      return {
        value: uo,
        inStock,
      };
    });

    return optStk;
  }
};

export default findOptionStock;
